import type {
  CreateManualEstimateReviewBody,
  ManualEstimateReviewStage,
  ManualEstimateReviewTracker,
  PaginatedResponse,
} from "@rebuild/shared";
import RestAPI from "../../utils/restAPI";

const ROUTE = "/rest/tools/manualEstimateReview";

export interface FetchManualEstimateReviewTrackersParams {
  stage?: ManualEstimateReviewStage;
  page: number;
  limit: number;
}

function requireResult<T>(result: T | null | undefined, action: string): T {
  if (result == null) {
    throw new Error(`Failed to ${action} manual estimate review`);
  }
  return result;
}

export async function fetchManualEstimateReviewTrackers(
  params: FetchManualEstimateReviewTrackersParams,
): Promise<PaginatedResponse<ManualEstimateReviewTracker>> {
  const query: Record<string, string | number> = { page: params.page, limit: params.limit };
  if (params.stage) {
    query.stage = params.stage;
  }
  return requireResult(await RestAPI.fetchRebuildAPI(ROUTE, "GET", query, "", true, false), "fetch");
}

export async function createManualEstimateReview(body: CreateManualEstimateReviewBody): Promise<ManualEstimateReviewTracker> {
  return requireResult(await RestAPI.fetchRebuildAPI(ROUTE, "POST", body, "data", true, false), "create");
}

export async function updateManualEstimateReviewTrackerStage(
  uuid: string,
  stage: ManualEstimateReviewStage,
): Promise<ManualEstimateReviewTracker> {
  return requireResult(await RestAPI.fetchRebuildAPI(`${ROUTE}/${uuid}`, "PUT", { stage }, "data", true, false), "update");
}
